import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  HealthcareFacilityStats,
  Stats,
} from "../../types/facility.definition";

interface DashboardState {
  stats: HealthcareFacilityStats;
  loading: boolean;
  error: string | null;
}
const defaultStats: Stats = {
  total: 0,
  lastWeek: 0,
  lastMonth: 0,
  lastYear: 0,
  weekChange: 0,
  monthChange: 0,
  yearChange: 0,
};
const initialState: DashboardState = {
  stats: {
    patientStatistics: defaultStats,
    doctorStatistics: defaultStats,
    appointmentStatistics: defaultStats,
  },
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchStatsRequest: (
      state,
      _action: PayloadAction<{ facilityId: string }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchStatsSuccess: (
      state,
      action: PayloadAction<HealthcareFacilityStats>
    ) => {
      state.stats = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchStatsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchStatsRequest, fetchStatsSuccess, fetchStatsFailure } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
